module.exports = __webpack_public_path__ + "img/gifiqr-vidensdeling.204b3963.jpg";